import styled from 'styled-components';

import { sizes } from '../../theme/sizes';

interface Props {
  mtSize?: 'none' | 'sm' | 'md' | 'lg' | 'auto' | 'initial';
  mlSize?: 'none' | 'sm' | 'md' | 'lg' | 'auto' | 'initial';
}

export const ButtonsContainer = styled.div<Props>`
  margin-top: ${({ mtSize }) => sizes[mtSize || 'initial']};
  margin-left: ${({ mlSize }) => sizes[mlSize || 'initial']};

  display: flex;
  gap: 0.5em;

  & > * {
    flex: 1;
  }

  & button,
  & a {
    display: flex;
    align-items: center;
    margin-top: 0;
    justify-content: center;
    text-align: center;
  }
`;

// ActionButtonsContainer is a flex container for grouping buttons aligned to the right (end) of the container.
// Buttons inside will have natural width and be spaced evenly, suitable for action bars or modal footers.
export const ActionButtonsContainer = styled(ButtonsContainer)`
  justify-content: flex-end;

  & > * {
    flex: 0;
  }
`;
